import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {is_mobile} from "./utils";

gsap.registerPlugin(ScrollTrigger);

function carbon_mask() {
  gsap
    .timeline({
      paused: true,
      duration: 1,
      scrollTrigger: {
        trigger: ".city_order",
        start: is_mobile ? "top-=200px top" : "top-=200px top",
        end: "bottom bottom",
        scrub: true
        // markers: true
      }
    })
    .fromTo(
      ".carbon-mask",
      1,
      {
        maskSize: "0vw"
      },
      {
        ease: "expo.inOut",
        maskSize: is_mobile ? "35000vw" : "8700vw"
      },
      0
    )
    .from(
      ".carbon-mask img",
      0.1,
      {
        autoAlpha: 0
      },
      0
    );
}

function flash_mask() {
  gsap
    .timeline({
      paused: true,
      scrollTrigger: {
        trigger: ".main_flash",
        start: is_mobile ? "top+=13% top" : "top+=16% top",
        end: "bottom bottom",
        scrub: 0.3
        // markers: true
      }
    })
    .fromTo(
      ".main_flash_bg",
      {
        maskSize: "0vw"
      },
      {
        maskSize: is_mobile ? "1000vw" : "800vw",
      },
    )
    .to('.main_flash', .01, {
        zIndex: 2
      }, 0
    )
  ;
}

export {carbon_mask, flash_mask};
